export function isValidEmail(raw: string): boolean {
  if (!raw) return false
  const value = raw.trim()

  // un único @
  const atCount = (value.match(/@/g) || []).length
  if (atCount !== 1) return false

  // No espacios ni comillas ni caracteres raros
  if (/[^\S\r\n]/.test(value)) return false
  if (/["'(),:;<>\\]/.test(value)) return false

  const [local, domain] = value.split("@")

  // local-part: letras, números, punto, guion y guion_bajo. Sin ñ ni acentos.
  if (!/^[A-Za-z0-9._-]+$/.test(local)) return false
  if (local.startsWith(".") || local.endsWith(".")) return false
  if (local.includes("..")) return false

  // dominio: letras, números, punto y guion. Sin ñ ni acentos
  if (!/^[A-Za-z0-9.-]+$/.test(domain)) return false
  if (domain.startsWith("-") || domain.endsWith("-")) return false
  if (domain.startsWith(".") || domain.endsWith(".")) return false
  if (domain.includes("..")) return false

  // TLD mínimo 2 letras
  const parts = domain.split(".")
  const tld = parts[parts.length - 1]
  if (!tld || !/^[A-Za-z]{2,}$/.test(tld)) return false

  return true
}
